/*
 * File Created: Sunday, 7th May 2023 4:30:38 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import React from 'react'
import { Outlet } from "react-router-dom";
import Appbar from "../Appbar/Appbar";
import Footer from "../footer/Footer";
import useScrollTrigger from "@mui/material/useScrollTrigger";

function Layout(): JSX.Element {
  // const location = useLocation();
  const threshold = useScrollTrigger({
    disableHysteresis: true,
    threshold: 450,
  });

  return (
    <React.Fragment>
      <Appbar
        sx={{
          position: threshold ? "sticky" : "static",
          top: 0,
        }}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>
      <Divider flexItem orientation='horizontal' />
      <Footer />
    </React.Fragment>
  )
}

export default Layout